import { bool, node, oneOf, string } from 'prop-types';
import React from 'react';
import { styleOverrideReason } from '@ids/core';
import { ContentWrapper, InnerContainer } from './StyledModalDialog';

// eslint-disable-next-line react/function-component-definition
const ModalContent = function ModalContent(props) {
  const { alignment, children, overflow, maxHeight, ...restProps } = props;

  return (
    <ContentWrapper overflow={overflow ? 1 : 0} {...restProps}>
      <InnerContainer
        alignment={alignment}
        maxHeight={maxHeight}
        overflow={overflow ? 1 : 0}
        tabIndex={overflow ? '0' : null}
      >
        {children}
      </InnerContainer>
    </ContentWrapper>
  );
};

ModalContent.propTypes = {
  /**
   * Alignment  of modal content
   */
  alignment: oneOf(['center', 'left', 'none']),
  /**
   * Content for modal dialog
   */
  children: node,
  /**
   * If content is overflowing
   */
  // eslint-disable-next-line react/boolean-prop-naming
  overflow: bool,
  /**
   * If content is overflowing allow user to set max height
   */
  maxHeight: string,
  /**
   * When `style` or `className` prop is provided, provide the reason behind the override.
   */
  styleOverrideReason
};

ModalContent.defaultProps = {
  alignment: 'center',
  maxHeight: '',
  children: null,
  overflow: false,
  styleOverrideReason: undefined
};

ModalContent.displayName = 'ModalContent';
export default ModalContent;
